import type { Organization, PremiumService, Service } from "@App/types";
import { getConfig } from "@App/utils/getConfig";

export const getServiceNameLabel = (
  organization: Organization,
  service: Service | null,
  premiumServices: PremiumService[] | null,
): string => {
  const showService = getConfig(organization).wording.services.label.useServiceName;
  const showPremiumServices = getConfig(organization).wording.services.label.usePremiumServiceNames;

  let serviceLabel = "";

  if (showService) serviceLabel += service?.pivot?.display_name || service?.name;
  if (showService && showPremiumServices && premiumServices && premiumServices.length > 0)
    serviceLabel += ", ";
  if (showPremiumServices && premiumServices && premiumServices.length > 0) {
    premiumServices.forEach((premiumService, idx) => {
      serviceLabel += premiumService.name;
      if (idx < premiumServices.length - 1) serviceLabel += ", ";
    });
  }

  return serviceLabel;
};
